import { Paper } from "@mui/material";
import { BookStatus } from "../../constants/Constants";
import { GetRommDetsName } from "../../constants/pojoservice";
import "../createRoom/Room.css";


const RoomBanquetView = ({ data, handleRoomBanquetClick, }) => {

    return (
        <Paper
            key={data.id}
            elevation={0}
            autoHeight
            onClick={() => handleRoomBanquetClick(data)}
            className="room-data-container"
            sx={{
                borderRadius: 4,
                backgroundColor: (data?.roomBookedStatus ?? BookStatus.No_Booking) === BookStatus.No_Booking ? "white" : "#c7b1b1ff",
            }}>
            <div style={{
                whiteSpace: 'pre-wrap', overflowWrap: 'break-word', textAlign: 'center',
                justifyContent: 'center', alignItems: 'center'
            }}>
                <p style={{
                    whiteSpace: 'pre-wrap', overflowWrap: 'break-word',
                    fontSize: '14px', justifyContent: 'center', alignItems: 'center', alignContent: 'center',
                    padding: '2px'
                }}>{GetRommDetsName(2, data)}</p>
                <center>
                    <p style={{
                        whiteSpace: 'pre-wrap', overflowWrap: 'break-word', textAlign: 'center',
                        fontSize: '15px', justifyContent: 'center', alignItems: 'center'
                        , padding: '2px'
                    }}><b>{GetRommDetsName(1, data)}</b></p>
                    <p style={{
                        whiteSpace: 'pre-wrap', overflowWrap: 'break-word', textAlign: 'center',
                        fontSize: '15px', justifyContent: 'center', alignItems: 'center'
                        , padding: '2px'
                    }}><b>{GetRommDetsName(3, data)}</b></p>
                </center>
            </div>
        </Paper>
    )
}

export { RoomBanquetView };